<div class="split-view" [class.split-view-collapsed]="isCollapsed()">
  <aside class="split-view-sidebar">
    <div class="split-view-sidebar-content">
      <ng-content select="[splitViewLeft]"></ng-content>
    </div>
  </aside>

  <main class="split-view-content">
    <div class="split-view-content-inner">
      <ng-content select="[splitViewRight]"></ng-content>
    </div>
  </main>
</div>
